import Vue from 'vue';
import request from '../../request';

function initState() {
  return {
    filters: {
      bookingCode: '',
    },
    loading: false,
    data: [],
    filteredData: [],
  };
}

export default {
  namespaced: true,
  state: initState(),
  mutations: {
    setLoading(state, loading) {
      Object.assign(state, { loading });
    },
    setBookings(state, data) {
      Vue.set(state, 'data', data);
      Vue.set(state, 'filteredData', data);
    },
    setFilter(state, payload) {
      Object.assign(state.filters, { [payload.filter]: payload.val });
    },
    setFilteredBookings(state, newBookings) {
      Object.assign(state, { filteredData: newBookings });
    },
  },
  actions: {
    get(context) {
      return new Promise((resolve) => {
        const url = `${process.env.API_URL}activity_booking`;
        const data = { };
        context.commit('setLoading', true);
        request.make({
          type: 'GET',
          url,
          data,
        }, (err, res) => {
          context.commit('setLoading', false);
          if (res.status === 200) {
            context.commit('setBookings', res.body.data);
            resolve();
          }
          if (res.status === 404) {
            context.commit('setBookings', []);
            resolve();
          }
        });
      });
    },
    willBePaid(context, payload) {
      return new Promise((resolve) => {
        const url = `${process.env.API_URL}activity_booking/willBePaid`;
        request.make({
          type: 'POST',
          url,
          data: payload,
        }, () => {
          resolve();
        });
      });
    },

    setBookingCodeFilter(context, payload) {
      context.commit('setFilter', { filter: 'bookingCode', val: payload });
      context.dispatch('applyFilters');
    },
    applyFilters(context) {
      let newBookings = context.state.data;
      if (context.state.filters.bookingCode !== '') {
        newBookings = newBookings.filter(booking =>
        booking.booking_code.toLowerCase()
        .indexOf(context.state.filters.bookingCode.toLowerCase()) !== -1,
        );
      }
      context.commit('setFilteredBookings', newBookings);
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/admin/bookings.js